import '../components/header-bar/header-bar';
import '../components/form/button-stateful';
import '../components/form/input-statefull';

import { requestHandler, showMessage } from './tools';

(function() {
    const backButton = document.querySelector('#back-btn') as any;
    const forgotPasswordBtn = document.querySelector('#auth-action-forgot-password-btn') as any;
    const forgotPasswordForm = document.querySelector('#forgot-auth-form') as HTMLFormElement;
    const emailInput = forgotPasswordForm.querySelector('[type=email]') as HTMLInputElement;

    emailInput.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            forgotPassword();
        }
    });

    const forgotPassword = () => {
        const emailInput = forgotPasswordForm.querySelector('[type=email]') as HTMLInputElement;
        const email = emailInput.value;
        const source = 'famelab-portal';

        forgotPasswordBtn.setAttribute('state', 'loading');
        showErrorMessage('');
        requestHandler({ url: '/v2/auth/forgot-password', method: 'POST', payload: JSON.stringify({ email, source }) })
            .then(data => {
                const response = JSON.parse(data?.data);
                showSuccessMessage();
                showMessage(response?.message);
                forgotPasswordBtn.setAttribute('state', '');
            }).catch(e => {
                forgotPasswordBtn.setAttribute('state', '');
                showErrorMessage(e.message, email);
                showMessage(e.message);
                console.log('error', e);
            });

    };
    forgotPasswordBtn.addEventListener('click', forgotPassword);
    backButton.addEventListener('click', () => history.back());

    function showErrorMessage(message, email?) {
        const errorMessageContainer = document.querySelector('.form-input-error-message') as HTMLDivElement;
        if (message) {
            errorMessageContainer.style.display = 'block';
        } else {
            errorMessageContainer.style.display = 'none';
        }

        const url = `signup${email ? `?email=${email}`: ''}`;

        errorMessageContainer.innerHTML = message;
        const createAccountLink = document.querySelector('.create__account') as HTMLAnchorElement;
        createAccountLink.innerHTML = 'Or create an account';
        createAccountLink.href = url;
    }

    function showSuccessMessage() {
        forgotPasswordForm.style.display = 'none';
        const successMessageText = document.querySelector('.success-message-text') as HTMLDivElement;
        successMessageText.style.display = 'flex';
    }
})();
